// Generated by CoffeeScript 1.10.0
(function() {


}).call(this);
